








































































import { Vue, Component } from "vue-property-decorator";
import BaseView from "@/components/BaseView.vue";
import BaseDataForm from "@/components/template/BaseDataForm.vue";
import InputDataForm from "@/components/template/InputDataForm.vue";
import { RawTemplate } from "@/store/template/types";
import VariablesForm from "@/components/template/VariablesForm.vue";
import InputsForm from "@/components/template/InputsForm.vue";
import FormBuilder from "@/components/template/FormBuilder.vue";
import NewTemplateSummary from "@/components/template/NewTemplateSummary.vue";
import Spinner from "@/components/Spinner.vue";

@Component({
  components: {
    BaseView,
    BaseDataForm,
    FormBuilder,
    NewTemplateSummary
  }
})
export default class TemplateNew extends Vue {
  // Vuex store with lightweight typed wrapper
  readonly store = this.$store.direct;
  // Component constants
  title: string = "Nueva Plantilla";
  subtitle: string = "Crear una nueva plantilla para uso en cargas masivas";
  info = null;
  // Component variables
  step: number = 1;
  // Component methods
  saveBaseData(data: Partial<RawTemplate>) {
    this.store.commit.template.UPDATE_SELECTED(data);
    this.step = 2;
  }

  get loading() {
    return this.store.state.loading;
  }

  set loading(val: number) {
    return;
  }

  get master() {
    return this.store.state.template.selected;
  }

  async created() {
    if (this.$route.params.id) {
      await this.store.dispatch.template.find(this.$route.params.id);
    }

    this.store.commit.form.CLEAR_SELECTED();
  }

  cancel() {
    this.store.commit.template.CLEAR_SELECTED();
    this.$router.back();
  }

  action() {
    if (this.master && this.master.id) {
      this.update();
    } else {
      this.create();
    }
  }

  async create() {
    let result = await this.store.dispatch.template.create();
    if (result.error) {
      this.store.commit.PUSH_MESSAGE({
        message: "No se pudo crear la plantilla. Intente nuevamente.",
        type: "error"
      });
    } else {
      this.store.commit.PUSH_MESSAGE({
        message: "La plantilla se ha creado correctamente.",
        type: "success"
      });
      this.store.commit.template.CLEAR_SELECTED();
      this.$router.push("/templates");
    }
  }

  async update() {
    let result = await this.store.dispatch.template.update(
      this.master.id as string
    );
    if (result.error) {
      this.store.commit.PUSH_MESSAGE({
        message: "No se pudo guardar la plantilla. Intente nuevamente.",
        type: "error"
      });
    } else {
      this.store.commit.PUSH_MESSAGE({
        message: "La plantilla se ha guardado correctamente.",
        type: "success"
      });
      this.store.commit.template.CLEAR_SELECTED();
      this.$router.push("/templates");
    }
  }
}
